import { httpAuth } from "@/api/httpAuth";
import { httpPublic } from "@/api/httpPublic";

export const obfuscationRequests = {
  obfuscationCreate: ({ context, data } = {}) => {
    return httpAuth.post("/v1/obfuscation/create", { context, json: data }).json();
  },
  obfuscationGetWithUsername: ({ context, data } = {}) => {
    return httpPublic.post("/v1/obfuscation/get_with_username", { context, json: data }).json();
  },
};
